import { forwardRef } from 'react';
import { Box as MUIBox, BoxProps as MUIBoxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import {
  unstable_extendSxProp as extendSxProp,
  type SystemProps,
} from '@mui/system';

// MUI v9 removed system style props (display, gap, mb, etc.) from Box in favour
// of the `sx` prop. We keep the old ergonomics by accepting system props and
// folding them into `sx` at runtime via MUI's own `extendSxProp` helper.
export type BoxProps = Omit<MUIBoxProps, 'ref'> & SystemProps<Theme>;

export const Box = forwardRef<HTMLDivElement, BoxProps>(
  function Box(props, ref) {
    return <MUIBox ref={ref} {...extendSxProp(props)} />;
  },
);
